(function () {
  if (window.__ffOtherDeviceBrandsMegaInit) return;
  window.__ffOtherDeviceBrandsMegaInit = true;

  function getRoot(from) {
    return from && from.closest ? from.closest('other-device-brands-mega') : null;
  }

  function keepMenuOpen(root) {
    const details = root && root.closest('details');
    const headerMenu = root && root.closest('header-menu');
    if (details) {
      details.setAttribute('open', '');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }
    if (headerMenu) {
      headerMenu.ignoreScrollCloseUntil = Date.now() + 1000;
      if (headerMenu.header) headerMenu.header.preventHide = true;
    }

    const content = root.closest('.mega-menu__content');
    if (content && typeof content.focus === 'function') {
      try {
        content.focus({ preventScroll: true });
      } catch (error) {
        content.focus();
      }
    }
  }

  function openBrand(root, key) {
    if (!root || !key) return;

    const picker = root.querySelector('[data-ff-brands-picker]');
    if (picker) {
      picker.hidden = true;
      picker.setAttribute('hidden', '');
    }

    root.querySelectorAll('[data-ff-brand-panel]').forEach((panel) => {
      const match = panel.getAttribute('data-ff-brand-panel') === key;
      panel.hidden = !match;
      panel.classList.toggle('is-active', match);
      if (match) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    root.classList.add('is-brand-open');
    keepMenuOpen(root);
  }

  function showPicker(root, keepOpen) {
    if (!root) return;

    const picker = root.querySelector('[data-ff-brands-picker]');
    if (picker) {
      picker.hidden = false;
      picker.removeAttribute('hidden');
    }

    root.querySelectorAll('[data-ff-brand-panel]').forEach((panel) => {
      panel.hidden = true;
      panel.setAttribute('hidden', '');
      panel.classList.remove('is-active');
    });

    root.classList.remove('is-brand-open');
    if (keepOpen) keepMenuOpen(root);
  }

  document.addEventListener(
    'click',
    (event) => {
      const openBtn = event.target.closest('[data-ff-open-brand]');
      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();
        openBrand(getRoot(openBtn), openBtn.getAttribute('data-ff-open-brand'));
        return;
      }

      const backBtn = event.target.closest('[data-ff-brands-back]');
      if (backBtn) {
        event.preventDefault();
        event.stopPropagation();
        showPicker(getRoot(backBtn), true);
      }
    },
    true
  );

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || details.open) return;
      details.querySelectorAll('other-device-brands-mega').forEach(showPicker);
    },
    true
  );

  if (!customElements.get('other-device-brands-mega')) {
    customElements.define(
      'other-device-brands-mega',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.classList.contains('is-brand-open')) showPicker(this);
        }
      }
    );
  }
})();
